import { render, staticRenderFns } from "./optsPrice.vue?vue&type=template&id=78d7fa71&scoped=true"
import script from "./optsPrice.vue?vue&type=script&lang=js"
export * from "./optsPrice.vue?vue&type=script&lang=js"
import style0 from "./optsPrice.vue?vue&type=style&index=0&id=78d7fa71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7fa71",
  null
  
)

export default component.exports